import { Button, Drawer, Form } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/store';
import { uiModel } from 'entities/ui';
import { ComponentModes } from 'shared/enums';
import { useEffect, useState } from 'react';
import { getTitle } from '../lib';
import { SubstitutionFormData } from '../types';
import style from './index.module.scss';
import { EditSubctitution } from './edit-substitution';
import { CreateSubstitution } from './create-substitution';
import { AddSubstitution } from './add-subtitution';

export const СontrolDrawer = () => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm<SubstitutionFormData>();
  const { submit } = form;
  const [loading, setLoading] = useState<boolean>(false);
  const { controlDrawer, buttonDisabled } = useAppSelector(uiModel.Substitutions.selectors.selectSubstitutions);

  const onClose = () => {
    dispatch(uiModel.Substitutions.actions.closeSubstitutionControlDrawer());
  };

  const onClick = () => {
    submit();
  };

  useEffect(() => {
    if (!controlDrawer?.isOpen) {
      form.resetFields();
    }
  }, [controlDrawer?.isOpen]);

  return (
    <Drawer
      forceRender
      width={600}
      title={getTitle(controlDrawer?.mode, controlDrawer?.substitution.type)}
      extra={
        controlDrawer?.mode !== ComponentModes.view && (
          <div className={style.actions}>
            <Button onClick={onClose}>Отмена</Button>
            <Button type="primary" onClick={onClick} disabled={buttonDisabled} loading={loading}>
              OK
            </Button>
          </div>
        )
      }
      visible={controlDrawer?.isOpen}
      onClose={onClose}
      destroyOnClose
    >
      <div className={style.wrap}>
        {controlDrawer?.mode === ComponentModes.add ? (
          <AddSubstitution form={form} setLoading={setLoading} />
        ) : controlDrawer?.mode === ComponentModes.create ? (
          <CreateSubstitution form={form} />
        ) : (
          <EditSubctitution form={form} />
        )}
        {}
      </div>
    </Drawer>
  );
};
